import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';

export const CTA_AFTER_PUBLISH_MODAL_STORAGE_KEY = 'cta_after_publish_modal_hidden';

@Component({
    selector: 'web-cta-after-publish-modal',
    templateUrl: './cta-after-publish-modal.component.html',
    styleUrls: ['./cta-after-publish-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule, TranslateModule, TooltipModule, CdkCopyToClipboard],
})
export class CtaAfterPublishModalComponent {
    private readonly bsModalRef = inject(BsModalRef);

    public readonly doNotShowAgain = signal(false);

    /** Passed via BsModalService initialState */
    public pageUrl: string = '';
    public isOnboardingWizard: boolean = false;
    public showPaidAlert: boolean = false;

    public onToggleCheckbox(checked: boolean): void {
        this.doNotShowAgain.set(checked);
    }

    public onConfirm(): void {
        if (this.doNotShowAgain()) {
            localStorage.setItem(CTA_AFTER_PUBLISH_MODAL_STORAGE_KEY, 'true');
        }

        this.bsModalRef.hide();
    }

    public onClose(): void {
        this.bsModalRef.hide();
    }
}
